import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { useState } from 'react';

type Props = Omit<TextFieldProps, 'onChange' | 'value'> & {
  onSearch: (value: string) => any;
  onClear?: () => any;
  initialValue?: string;
};

export function SearchBox(props: Props) {
  const { initialValue, onSearch, onClear, className, placeholder, sx, ...rest } = props;
  const [value, setValue] = useState(initialValue || '');

  function _onClear() {
    setValue('');
    onClear ? onClear() : onSearch('');
  }

  return (
    <TextField
      size="small"
      value={value}
      onChange={(evt) => {
        const newValue = evt.target.value;
        setValue(newValue);
        onSearch(newValue);
      }}
      placeholder={placeholder || ''}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={_onClear} data-cy="searchbox-clear" edge="end">
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
      {...rest}
    />
  );
}
